import { GET } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/report/${endpoint}`;
};

export const getCustomersSummary = (token) => {
  const endpoint = getEndpointWithPrefix('customers/summary');
  return GET(endpoint, token);
};
